import {default as EventEmitter} from 'events';
import {default as Symbol} from 'es6-symbol';
import {default as Promise} from 'es6-promise';
import {default as context} from 'util/context.js';
import {default as handler} from 'util/handler.js';
import {default as debugModule} from 'util/debug.js';
import {default as $script} from 'scriptjs';


const debug = debugModule(__filename);


const _singleton = Symbol();


class CommentCount extends EventEmitter {

    constructor(singletonToken) {
        if (_singleton !== singletonToken)
            throw new Error('Cannot instantiate directly.');

        super();

        this.civilScript = 'https://d2ylgh2cnbot5i.cloudfront.net/v1/embed.js';
        this._initialized = false;

        handler.addApp('CommentCount', this);
    }

    static get instance() {
        if(!this[_singleton])
            this[_singleton] = new CommentCount(_singleton);

        return this[_singleton];
    }

    init({ autoRefresh = false, refreshInterval = 60000 } = {}) {

        if(!this._initialized) {
            this.config = {
                autoRefresh,
                refreshInterval
            };
            this._shimMarkup();
            this._loadScript();
        }

        if(this.config.autoRefresh && this.config.refreshInterval) {
            window.setInterval(() => {
                debug(`${this.config.refreshInterval/1000} sec increment refresh`);
                this.refresh();
            }, this.config.refreshInterval);
        }

        return this.ready();
    }

    destroy() {
        throw new Error('This application cannot self destruct.');
    }

    /* Initialize if not already, or perform refresh */
    refresh(callback) {
        if(this._initialized) {
            debug('Refreshing comment counts...');
            this._shimMarkup();
            window.CivilEmbed.refresh();
        } else {
            this.init();
        }

        if(typeof callback === 'function'){
            this.ready().then(callback);
        }
    }

    ready() {
        const promise = new Promise((resolve, reject) => {
            if(this._initialized) {
                debug('Civil Comment Count script ready...');
                resolve({ success: true, message: 'Civil Comment Count script already loaded' });
            } else {
                debug("Civil Comment Count script not ready, waiting for 'ready' event...");
                this.on('ready', function() {
                    resolve({ success: true, message: "Received 'ready' event" });
                });

                setTimeout(() => {
                    if(!window.CivilEmbed)
                        reject({ success: false, message: 'Civil took too long, we gave up' });
                }, 60000);
            }
        });
        return promise;
    }

    _shimMarkup() {
        const countElements = document.getElementsByClassName('livefyre-commentcount');
        for(let element of Array.from(countElements)) {
            const href = element.parentElement.href;
            if(href && context.isPilotSection(href)) {
                // Not the most concise code, but to save overhead we avoid DOM traversal and date parsing unless the story passes the URL sanity check
                // This date is in UTC: 2017-08-03T19:40:15Z
                let epoch;
                try {
                    epoch = Date.parse(element.parentElement.parentElement.parentElement.parentElement.getElementsByClassName('timestamp')[0].getAttribute('title')); // eslint-disable-line no-unused-vars
                } catch (e) {
                    debug(`No timestamp present for story - will treat as Civil story: ${href}`)
                }
                // At this point we assume stories in the pilot section but without a pubdate are Civil;
                // they are injected by the Woven River script without a pubdate
                if(epoch && !context.isPilotPubdate(epoch))
                    continue;

                debug(`Found Civil pilot story: ${href}`);
                // Add required markup for Civil Comment Count script
                element.className = 'civil-comment-count';
                element.dataset['siteId'] = context.siteId;
                element.dataset['language'] = 'en';
                element.dataset['id'] = element.dataset['lfArticleId'];
                // Remove LF markup
                delete element.dataset['lfArticleId'];
                delete element.dataset['lfSiteId'];
            }
        }

    }

    _loadScript() {
        $script(this.civilScript, () => {
            debug('Loaded Civil Comment Count script');
            this._initialized = true;
            this.emit('ready');
        });
    }

}


export default CommentCount.instance;


// WEBPACK FOOTER //
// ./src/apps/comment-count/main.js